module.exports = __webpack_public_path__ + "img/map_dark.1a563935.png";